import { z } from 'zod'

import { zCleanString } from '../utils'
import { Language } from './organization'

export type UserDTO = {
  email: string
  firstName: string
  id: string
  language?: Language
  lastName: string
  superAdmin: boolean
}

export type SudoContextUserDTO = {
  disabled: boolean
  email: string
  firstName: string
  id: string
  language?: Language
  lastName: string
  organizationIds: string[]
  superAdmin: boolean
}

export const sudoContextUserSchema = {
  disabled: z.boolean(),
  email: zCleanString.email(),
  firstName: zCleanString,
  language: z.nativeEnum(Language).optional(),
  lastName: zCleanString,
  organizationIds: z.array(zCleanString),
  superAdmin: z.boolean(),
}
